import { Actions } from '../../interfaces'
import { MaintenanceType } from '@/entities/public'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { MaintenanceType },
  actions: { [MaintenanceType.name]: actions },
}
